/**
 * Supplier side of a supplier <-> customer thread: the Messages window on the
 * Customers page.
 *
 * CR-8605: moved out of pages/Customers.tsx and onto the shared
 * SupplierMessageThread, so a failed load or a refused send says why. Also
 * opened by the bell a customer's message raises (`/customers?messages=<id>`).
 */

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import SupplierMessageThread from './SupplierMessageThread';
import { MessageSquare } from 'lucide-react';

interface CustomerChatDialogProps {
  supplierId: number;
  customerId: number;
  customerName: string;
  onClose: () => void;
}

export default function CustomerChatDialog({ supplierId, customerId, customerName, onClose }: CustomerChatDialogProps) {
  return (
    <Dialog open onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent className="max-w-lg flex flex-col max-h-[80vh]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <MessageSquare className="h-5 w-5 text-primary" />
            Messages — {customerName}
          </DialogTitle>
          <DialogDescription className="sr-only">
            Conversation with {customerName}
          </DialogDescription>
        </DialogHeader>
        <SupplierMessageThread
          supplierId={supplierId}
          customerId={customerId}
          listClassName="min-h-[250px]"
        />
      </DialogContent>
    </Dialog>
  );
}
